module.exports = __webpack_public_path__ + "img/superprivacy-icon-active.c5ec6e08.svg";